// extracted by mini-css-extract-plugin
module.exports = {"centeredContainer":"pages-login-login__centeredContainer--1PfFb"};